const prefix = ''

export const modelUrls = {
  'model.list': `${prefix}/models`,
  'model.view': (id = ':modelId') => `${prefix}/models/${id}`,
  'model.edit': (id = ':modelId') => `${prefix}/models/${id}/edit`,
  'model.add': `${prefix}/models/add`,
}
